import { render, staticRenderFns } from "./ownerDetailRoom.vue?vue&type=template&id=fd92ead4&scoped=true"
import script from "./ownerDetailRoom.vue?vue&type=script&lang=js"
export * from "./ownerDetailRoom.vue?vue&type=script&lang=js"
import style0 from "./ownerDetailRoom.vue?vue&type=style&index=0&id=fd92ead4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd92ead4",
  null
  
)

export default component.exports